import React from 'react'
import { Collapse } from 'react-bootstrap'
import { DivContentBox } from '../common/styled'
import ReactMarkdown from 'react-markdown'

const HowToGuidesItem = (item) => {
  const borderRadius = item.isOpen ? '10px 10px 0 0' : '10px 10px 10px 10px'
  return (
    <div className='ibox section-shadow'>
      <div
        className='ibox-title'
        onClick={() => item.onToggle(item)}
        style={{ borderRadius: borderRadius, cursor: 'pointer' }}
      >
        <i className={item.isOpen ? 'fa fa-chevron-down' : 'fa fa-chevron-right'} />
        <header>{item.title}</header>
      </div>
      <Collapse in={item.isOpen}>
        <div>
          <DivContentBox className='ibox-content table-responsive'>
            <ReactMarkdown>{item.content}</ReactMarkdown>
          </DivContentBox>
        </div>
      </Collapse>
    </div>
  )
}
export default HowToGuidesItem
